<script lang="ts">
  import { page } from "$app/state";
  import Header from "$lib/Header.svelte";
  import Footer from "$lib/Footer.svelte";
  // Import styles
  import "makeup-style/where-default.css";
  import "makeup-style/where-develop.css";
  import "$lib/assets/ishavskraft-font-faces.css";
  import "$lib/assets/ishavskraft-colors.css";
  import "$lib/assets/ishavskraft.css";
  import "$lib/assets/ishavskraft-interaction.css";
  import "$lib/assets/ishavskraft-icons.css";
</script>

<main class="grid grid-rows-[auto_1fr] min-h-[100dvh] items-center">
  <div class="container-for-one-row">
    <Header class="mb-1" />
  </div>
  <article>
    {#if String(page?.status).match(/^(204|400|401|403|404|410|501)$/)}
      <h1>Oi… Her var det tomt</h1>
      <p class="heading-2">Side ikke funnet</p>
      <p>Enten er nettadressen feil, eller siden er flyttet, kanskje med et uhell.</p>
      <p>Åpne «Meny» for hovedinngangene til nettsiden.</p>
    {:else if String(page?.status).match(/^(413|429|500|502|503|504)$/)}
      <h1>Oida…</h1>
      <p class="heading-2">Noe gikk galt ved lasting fra serveren</p>
      <p>
        Beklager for ulempen dette kanskje skaper! Men teamet vårt jobber hardt med å løse problemet
        så fort som mulig
      </p>
    {:else}
      <h1>Oida…</h1>
      <p class="heading-2">Noe gikk galt</p>
      <p>
        Beklager for ulempen dette kanskje skaper! Men teamet vårt jobber hardt med å løse problemet
        så fort som mulig
      </p>
    {/if}

    <p class="my-6">
      <a class="button" href="/">Gå til forsiden</a>
    </p>

    {#if page?.status}
      <hr />
      <section class="mb-8 italic children-my-0 flex gap-2">
        <h2 class="text-[1em] leading-inherit">{page.status}</h2>

        {#if page.error?.message}
          <p lang="en">{page.error.message}</p>
        {/if}
      </section>
    {/if}
  </article>
</main>

<div class="footer-container children-mt-0">
  <Footer />
</div>

<style lang="postcss">
  article {
    margin-inline: var(--space-edge-x);
    padding-block-end: var(--sticky-top, var(--s-4, 1em));
  }
</style>
